import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import light from './theme'
import icons from './icons'

import '@mdi/font/css/materialdesignicons.css'
import 'typeface-source-sans-pro'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    values: icons,
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: { light },
  },
})
